import React from 'react';
import logo from '../logo.png';

function Header({ user, onLogout, clientCount, onViewClients, onViewEventCoverage, onViewTech }) {
  const initials = user.name.slice(0, 2).toUpperCase();

  return (
    <header
      style={{
        background: '#fff',
        borderBottom: '1px solid #ede9e3',
        padding: '0 2.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 116,
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="ChalkWalk Design Studio" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
      </div>

      {/* User + logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <button
          onClick={onViewEventCoverage}
          style={{
            background: '#f5f3f0',
            border: '1px solid #e8e4e0',
            borderRadius: 8,
            padding: '7px 16px',
            fontSize: 13,
            color: '#444',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            fontWeight: 500,
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#444"><path d="M8 5v14l11-7z"/></svg>
          Event Coverage
        </button>
        <button
          onClick={onViewTech}
          style={{
            background: '#f5f3f0',
            border: '1px solid #e8e4e0',
            borderRadius: 8,
            padding: '7px 16px',
            fontSize: 13,
            color: '#444',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            fontWeight: 500,
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#444"><path d="M8 5v14l11-7z"/></svg>
          Tech
        </button>
        <button
          onClick={onViewClients}
          style={{
            background: '#1a1a1a',
            border: 'none',
            borderRadius: 8,
            padding: '7px 16px',
            fontSize: 13,
            color: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            fontWeight: 500,
          }}
        >
          Clients
          {clientCount > 0 && (
            <span style={{ background: '#dc2626', borderRadius: 20, padding: '1px 7px', fontSize: 11, fontWeight: 700 }}>
              {clientCount}
            </span>
          )}
        </button>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{user.name}</div>
          <div style={{ fontSize: 11, color: '#aaa' }}>{user.email}</div>
        </div>
        <div
          style={{
            width: 36,
            height: 36,
            background: '#5B4FCF',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 600,
            color: '#fff',
          }}
        >
          {initials}
        </div>
        <button
          onClick={onLogout}
          style={{
            background: '#f5f3f0',
            border: '1px solid #e8e4e0',
            borderRadius: 8,
            padding: '6px 14px',
            fontSize: 12,
            color: '#666',
          }}
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}

export default Header;
